import React from "react";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  makeStyles,
  Paper,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}));
const Homepage = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper>
        <CardHeader title="CPCM - Crosspoint Client Manager" />
        <Divider />
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item lg={6} sm={6} xl={3} xs={12}>
                <Button color="secondary" variant="contained" href="/referrals">
                  View Referrals
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xl={3} xs={12}>
                <Button color="secondary" variant="contained" href="/clients">
                  View Clients
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Paper>
    </div>
  );
};
export default Homepage;
